<div class="mam-gfx-params">
  @for (textField of getTextFields(); track textField.id) {
    <div class="mam-gfx-params__category mam-gfx-text">
      <div class="mam-gfx-params__label">{{ textField.label || "Text" }}</div>
      <div class="mam-gfx-params__block">
        <textarea
          class="mam-gfx-params__textarea"
          rows="3"
          [(ngModel)]="textField.text"
          (ngModelChange)="notify()"
        ></textarea>
      </div>
    </div>
  }

  @if (showDurationField()) {
    <div class="mam-gfx-params__category">
      <div class="mam-gfx-params__label">Duration</div>
      <div class="mam-gfx-params__duration-field">
        <div class="mam-gfx-params__duration-input-wrap">
          <span class="mam-gfx-params__duration-suffix">sec</span>
          <input
            type="number"
            class="mam-gfx-params__duration-input"
            [min]="durationMinSec"
            [max]="durationMaxSec"
            [step]="durationStepSec"
            [ngModel]="durationSeconds()"
            (ngModelChange)="onDurationSecondsChange($event)"
          />
        </div>
      </div>
    </div>
  }

  <div class="mam-gfx-params__category">
    <div class="mam-gfx-params__label">Scale and position</div>

    @if (getScaleField(); as scaleField) {
      <div class="mam-gfx-scale">
        <label class="mam-gfx-params__sub">Scale</label>
        <div class="mam-gfx-scale__row">
          <input
            type="range"
            class="mam-gfx-scale__slider"
            [min]="gfxScaleMin"
            [max]="gfxScaleMax"
            [step]="gfxScaleStep"
            [value]="graphicsScaleSelectedValue(scaleField)"
            (input)="onGfxScaleSliderInput(scaleField, $any($event.target).value)"
          />
          <input
            type="number"
            class="mam-gfx-scale__number"
            [min]="gfxScaleMin"
            [max]="gfxScaleMax"
            [step]="gfxScaleStep"
            [ngModel]="graphicsScaleSelectedValue(scaleField)"
            (ngModelChange)="onGraphicsScaleValueChange(scaleField, $event)"
          />
        </div>
      </div>
    }

    <div class="mam-gfx-params__layer-block">
      <label class="mam-gfx-params__sub">Layer</label>
      <div class="mam-gfx-params__layer-row">
        <evrideo-layer-input
          [zIndex]="graphicsInfo.zLayer"
          (zIndexChange)="onZLayerChange($event)"
          [minNumber]="0"
          [maxNumber]="9999"
          [showTooltip]="false"
        ></evrideo-layer-input>
      </div>
    </div>
  </div>

  @if (getMediaFields().length > 0) {
    <div class="mam-gfx-params__category">
      <div class="mam-gfx-params__label">Media</div>
      @for (media of getMediaFields(); track media.id) {
        <div class="mam-gfx-params__media-card">
          <div class="mam-gfx-params__media-title">{{ media.label }}</div>
          <div class="mam-gfx-params__row">
            <label class="mam-gfx-params__sub">Type</label>
            <icn-dropdown
              [large]="true"
              [selectedValue]="media.mediaType"
              (selectedValueChange)="media.mediaType = $event; notify()"
            >
              <icn-dropdown-item
                [title]="mediaTypeTitle(MediaTypeEnum.None)"
                [value]="MediaTypeEnum.None"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="mediaTypeTitle(MediaTypeEnum.MediaId)"
                [value]="MediaTypeEnum.MediaId"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="mediaTypeTitle(MediaTypeEnum.DynamicOption)"
                [value]="MediaTypeEnum.DynamicOption"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="mediaTypeTitle(MediaTypeEnum.Link)"
                [value]="MediaTypeEnum.Link"
              ></icn-dropdown-item>
            </icn-dropdown>
          </div>
          <div class="mam-gfx-params__row">
            <label class="mam-gfx-params__sub">Media ID</label>
            <icn-number-input
              [theme]="'white'"
              [min]="0"
              [max]="999999999"
              [step]="1"
              [value]="media.mediaId"
              (valueChange)="media.mediaId = $event; notify()"
            ></icn-number-input>
          </div>
          <div class="mam-gfx-params__block">
            <label class="mam-gfx-params__sub">Link</label>
            <input
              type="text"
              class="mam-gfx-params__input"
              [(ngModel)]="media.link"
              (ngModelChange)="notify()"
            />
          </div>
          <div class="mam-gfx-params__block">
            <label class="mam-gfx-params__sub">Dynamic</label>
            <input
              type="text"
              class="mam-gfx-params__input"
              [(ngModel)]="media.dynamic"
              (ngModelChange)="notify()"
            />
          </div>
          <div class="mam-gfx-params__row">
            <label class="mam-gfx-params__sub">Fit media</label>
            <icn-dropdown
              [large]="true"
              [selectedValue]="media.fitMedia"
              (selectedValueChange)="media.fitMedia = $event; notify()"
            >
              <icn-dropdown-item
                [title]="fitMediaTitle(MediaFit.IgnoreAspect)"
                [value]="MediaFit.IgnoreAspect"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="fitMediaTitle(MediaFit.LetterBox)"
                [value]="MediaFit.LetterBox"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="fitMediaTitle(MediaFit.StretchToCover)"
                [value]="MediaFit.StretchToCover"
              ></icn-dropdown-item>
            </icn-dropdown>
          </div>
        </div>
      }
    </div>
  }
</div>
